define([],
	function() {
		var injectCSS = function(source){
            var style = document.createElement("style");
            style.type = "text/css";
            style.appendChild(document.createTextNode(source));
            document.head.appendChild( style );
        }
		return injectCSS;
	}
);




//////////////////
// WEBPACK FOOTER
// ./utils/injectCSS.js
// module id = 10
// module chunks = 0